<template>
  <div>
    <v-toolbar flat color="transparent" style="background: transparent">
      <v-toolbar-title>
        <v-btn flat @click="goBack" style="line-height: 10px;">
          <span class="fas fa-chevron-left mr-2"></span>
          {{ $t('Back') }}
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <lang-dropdown></lang-dropdown>
    </v-toolbar>
    <div class="container" style="padding: 25px 0;">
      <template v-if="pagelist.length == 0">
        <div class="container text-xs-center">
          <div class="row">
            <div class="col s12 m6 offset-m3">
              <img src="/static/img/assets/get_started/no_page.png" alt class="responsive-img" />
              <h3 class="headline">{{ $t('You dont have any Facebook page or') }}</h3>
              <h5>{{ $t('No permission to access Facebook page') }}</h5>

              <a
                href="https://www.facebook.com/pages/creation/"
                target="_blank"
                class="btn"
                style="width: 100%; margin-bottom: 15px;"
                >{{ $t('If you dont have any Facebook page, Create new page') }}</a
              >
              <p>{{ $t('or') }}</p>
              <a href="javascript:void(0);" @click="logout" class="btn" style="width: 100%">{{
                $t('If you have page, Login again and Allow Facebook page permission')
              }}</a>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div>
          <transition name="fade" mode="out-in">
            <div v-if="stage == 'select-page'"></div>
            <div v-else-if="stage == 'confirm-install'"></div>
          </transition>
        </div>

        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          mode="out-in"
        >
          <div v-if="stage != 'confirm-install'">
            <div class="text-xs-center">
              <h3 class="headline" style="margin-bottom: 25px;">
                {{ $t('Select your Facebook Page to install Zwiz.ai chatbot') }}
                <!-- <template v-if="themelist.length > 0">
                  <span>{{themelist[0].themename}}</span>
                </template>-->
              </h3>

              <p style="margin_top: 45px; margin-bottom: 25px;">
                {{ $t("Only Admin page can install Chatbot. The page doesn't show up") }}
                <a
                  href="https://blog.zwiz.ai/%E0%B8%96%E0%B9%89%E0%B8%B2%E0%B9%80%E0%B8%9E%E0%B8%88%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >{{ $t('click') }}</a
                >
              </p>
            </div>

            <div class="pages">
              <div v-for="(page, index) in computedPage" :key="'page_' + page.id">
                <page-item v-model="computedPage[index]" class="page">
                  <div
                    slot="select-page"
                    style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; "
                    @click="onConfirmSubscribe(page)"
                    v-if="stage == 'select-page'"
                  ></div>
                </page-item>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="text-xs-center">
              <h3 class="headline" style="margin-bottom: 25px;">
                {{ $t('chatbot will be installed to') }}
              </h3>
            </div>
            <v-card style="max-width: 500px; margin: auto; border-radius: 10px; ">
              <v-card-text class="text-xs-center pt-5 pb-5">
                <div>
                  <v-avatar
                    :size="150"
                    color="grey lighten-4"
                    style="margin: auto; border: 1px solid #eee"
                  >
                    <img
                      class="circle"
                      :src="
                        'https://graph.facebook.com/' +
                          currentPage.id +
                          '/picture?width=100&height=100'
                      "
                      alt
                    />
                  </v-avatar>
                  <p class="headline primary--text mt-2 text-truncate">{{ currentPage.name }}</p>
                  <span class="page-role">
                    <template v-if="!currentPage.isAdmin">{{ $t('No permission') }}</template>
                    <template v-else>{{ pagerole }}</template>
                  </span>
                  <v-btn
                    color="primary"
                    @click="onSubscribeBot"
                    depressed
                    class="ma-0"
                    style="width: 100%; margin-top: 25px;"
                    >{{ $t('install bot') }}</v-btn
                  >
                </div>
              </v-card-text>
            </v-card>
          </div>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import Velocity from 'velocity-animate'
import Tags from '@/components/elements/Tags'
import IntentGroup from '@/components/view/intent/IntentGroup'
import PersistentMenu from '@/components/view/setting/PersistentMenu'
import { mapGetters, mapMutations } from 'vuex'
import PageItem from '@/components/view/allbots/PageItem'
import QuickReply from '@/components/view/chatbot/QuickReply'
import LangDropdown from '@/components/elements/LangDropdown'

export default {
  data: function() {
    return {
      currentView: 'select-page',
      stage: 'select-page',
      currentPageIndex: null,
      currentPage: null,
      themelist: [],
      selectedTheme: undefined
    }
  },
  components: {
    PageItem,
    LangDropdown
  },
  mounted: function() {
    let vm = this
    vm.getAllPublicTheme(function() {
      vm.selectedTheme = vm.themelist[0]
    })
  },
  computed: {
    ...mapGetters({
      botlist: 'botlist',
      isFacebook: 'isFacebook',
      pagelist: 'unsubscribedPage',
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    pagerole: function() {
      let vm = this
      var page = this.currentPage
      if (!this.currentPage) {
        return ''
      } else {
        console.log(page)
        if (page.perms) {
          $.each(page.perms, function(index, val) {
            if (val == 'ADMINISTER') {
              return vm.$t('Administer')
            }
          })
        } else if (page.tasks) {
          $.each(page.tasks, function(index, val) {
            if (val == 'MANAGE') {
              return vm.$t('Administer')
            }
          })
        } else {
          return ''
        }
      }
    },
    computedPage: function() {
      var vm = this
      var pagelist = this.pagelist.sort(function(a, b) {
        if (a.tasks.indexOf('MANAGE') > -1 && b.tasks.indexOf('MANAGE') == -1) {
          return -1
        } else if (a.tasks.indexOf('MANAGE') == -1 && b.tasks.indexOf('MANAGE') > -1) {
          return 1
        } else {
          return 0
        }
      })
      if (vm.currentPageIndex == null) {
        vm.currentPage = null
        return pagelist
      }

      return pagelist.filter(function(item) {
        if (item.id == vm.currentPageIndex) {
          vm.currentPage = item
        }
        return item.id == vm.currentPageIndex
      })
    },
    welcomeCustomerSays: {
      get() {
        let vm = this
        if (vm.welcome && vm.welcome.customerSay && vm.welcome.customerSay != '') {
          // console.log(vm.welcome.customerSay)
          var customerSays = []
          customerSays = vm.welcome.customerSay.split(',')
          var result = []
          $.each(customerSays, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.welcome.customerSay = result.join(',')
      }
    },
    welcomeChoices: {
      get() {
        let vm = this
        if (vm.welcome && vm.welcome.choice && vm.welcome.choice != '') {
          // console.log(vm.welcome.choice)
          var choices = []
          choices = vm.welcome.choice.split(',')
          var result = []
          $.each(choices, function(index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function(index, val) {
          result.push(val.text)
        })
        vm.welcome.choice = result.join(',')
      }
    }
  },
  methods: {
    onConfirmSubscribe(page) {
      var vm = this
      if (page.tasks.indexOf('MANAGE') > -1) {
        this.stage = 'confirm-install'
        this.currentPageIndex = page.id
        this.currentPage = page
      } else {
        vm.$swal.fire({
          title: vm.$t('No permission to access Facebook page'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          html:
            '<p style="margin_top: 45px; margin-bottom: 25px;">' +
            '<a href="https://blog.zwiz.ai/%E0%B8%96%E0%B9%89%E0%B8%B2%E0%B9%80%E0%B8%9E%E0%B8%88%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%95%E0%B9%89%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B8%B1%E0%B9%89/"target="_blank" ' +
            'rel="noopener noreferrer">' +
            vm.$t('If the page that you want to install does not appear ?') +
            ' <i class="fas fa-question-circle" ></i></a></p>'
        })
      }
    },
    logout: function() {
      var vm = this
      var isFacebook = vm.isFacebook
      vm.$store.dispatch('logout', null).then()
      if (isFacebook) {
        vm.$router.push('/' + vm.currentLang + '/login')
      } else {
        vm.$router.push('/' + vm.currentLang + '/nigol')
      }
    },
    onSubscribeBot: function() {
      if (this.currentPageIndex == null || this.selectedTheme == null) {
        return
      }
      if (this.currentPage) {
      }
      let vm = this
      let page = this.currentPage
      let data = {
        pageid: page.id,
        page_access_token: page.access_token,
        theme: this.selectedTheme.themeid,
        pagename: page.name,
        ownerid: this.$store.state.userid,
        status: false
      }
      vm.$store.dispatch('loading')
      // vm.$store.dispatch('addModalWelcome')
      api.newSubscribe(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        vm.$store.dispatch('updateNewBotlist').then(
          function() {
            var bot = null
            $.each(vm.botlist, function(index, val) {
              if (val.pageid == page.id) {
                bot = val
                return false
              }
            })
            if (bot != null) {
              var utm = ''
              if (vm.$route.query.utm_source) {
                utm = '_' + vm.$route.query.utm_source
              }
              vm.$store.dispatch('selectBot', bot)
              vm.$ga.event('event', 'subscribe', bot.pagename + utm)
              vm.$store.dispatch('loading')
              vm.$router.push('/' + vm.currentLang + '/setup')
            } else {
              vm.$emit('close')
              vm.$store.dispatch('loading')
            }
          },
          function(error) {
            vm.$emit('close')
            vm.$store.dispatch('loading')
            vm.errorMessage = 'Can not update chatbot'
          }
        )
      })
    },
    getAllPublicTheme: function(callback) {
      let vm = this
      api.getAllPublicTheme({ appid: config.appid }, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        vm.themelist = response.data
        callback()
      })
    },
    goBack: function() {
      var vm = this
      if (vm.currentView == 'select-page') {
        if (vm.stage == 'select-page') {
          vm.$emit('close')
        } else if (vm.stage == 'confirm-install') {
          vm.currentPageIndex = null
          vm.stage = 'select-page'
        }
      }
    },
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/getstarted/GetStarted.vue